import React from 'react';
import useDimensions from 'react-use-dimensions';
import './TrackingFace.scss';

const TrackingFace = (props) => {
  const {
    cursorX,
    cursorY,
    viewportWidth,
    viewportHeight,
  } = props;
  const [headRef, headSize] = useDimensions();
  const {
    width: headWidth,
    x: headX,
    y: headY,
  } = headSize;
  const headRadius = (headWidth / 2);
  const leftMax = headX - headRadius;
  const rightMax = viewportWidth - headX;
  const topMax = headY + headRadius;
  const bottomMax = viewportHeight - headY;
  const cursorIsTop = Boolean(cursorY < (headY + headRadius));
  const cursorIsLeft = Boolean(cursorX < (headX + headRadius));
  const posLeftPercentage = cursorIsLeft ? (
    Math.floor(50 + (((cursorX - (headX + headRadius)) / leftMax) * 50))
  ) : (
    Math.floor(50 + (((cursorX - (headX + headRadius)) / rightMax) * 50))
  );
  const posTopPercentage = cursorIsTop ? (
    Math.floor(50 + (((cursorY - (headY + headRadius)) / topMax) * 50))
  ) : (
    Math.floor(50 + (((cursorY - (headY + headRadius)) / bottomMax) * 50))
  );
  // console.log({ posLeftPercentage });
  // const skewX = cursorIsLeft ? (
  //   Math.floor((posLeftPercentage - 50) / 100 * 12)
  // ) : (
  //   Math.floor(-(posLeftPercentage - 50) / 100 * 12)
  // );
  // const skewY = cursorIsTop ? (
  //   Math.floor((posTopPercentage - 50) / 100 * 12)
  // ) : (
  //   Math.floor(-(posTopPercentage - 50) / 100 * 12)
  // );
  // const transform = `translate(-50%, -50%) skewX(${skewX}deg) skewY(${skewY}deg)`;
  const transform = `translate(-50%, -50%)`;
  const faceTransforms = {
    top: `${posTopPercentage}%`,
    left: `${posLeftPercentage}%`,
    transform,
  };
  return (
    <div className="little-man">
      <div className="head" ref={headRef}>
        <svg viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg">
          <path d="M29.8 0C13.403 0 0 13.331 0 29.8c0 16.468 13.331 29.8 29.8 29.8 16.468 0 29.8-13.332 29.8-29.8C59.6 13.33 46.267 0 29.8 0zm0 57.318c-15.185 0-27.52-12.333-27.52-27.518S14.615 2.28 29.8 2.28c15.185 0 27.518 12.334 27.518 27.519 0 15.185-12.333 27.518-27.518 27.518z" fill="#282F3A" />
        </svg>
        <div className="face-boundaries">
          <div className="face" style={faceTransforms}>
            <svg viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg">
              <g fill="#282F3A" fillRule="nonzero">
                <path d="M12.8-18C-3.597-18-17-4.669-17 11.8c0 16.468 13.331 29.8 29.8 29.8 16.468 0 29.8-13.332 29.8-29.8C42.6-4.67 29.267-18 12.8-18zm0 57.318c-15.185 0-27.519-12.333-27.519-27.518S-2.385-15.72 12.8-15.72c15.185 0 27.518 12.334 27.518 27.519 0 15.185-12.333 27.518-27.518 27.518z" />
                <g transform="translate(.536 .357)">
                  <path d="M20.817 0c-1.711 0-3.137 1.426-3.137 3.137 0 1.71 1.426 3.137 3.137 3.137s3.137-1.426 3.137-3.137C24.025 1.426 22.599 0 20.817 0z" />
                  <circle cx="3.137" cy="3.137" r="3.137" />
                  <path d="M11.977 20.39c-4.278 0-7.7-3.494-7.7-7.7h-2.21c0 5.49 4.492 9.98 9.981 9.98 5.49 0 9.981-4.49 9.981-9.98h-2.21c-.071 4.277-3.565 7.7-7.842 7.7z" />
                </g>
              </g>
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrackingFace;
